import { render, staticRenderFns } from "./AppLoader.vue?vue&type=template&id=c88ba8c2&scoped=true&"
import script from "./AppLoader.vue?vue&type=script&lang=ts&"
export * from "./AppLoader.vue?vue&type=script&lang=ts&"
import style0 from "./AppLoader.vue?vue&type=style&index=0&id=c88ba8c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88ba8c2",
  null
  
)

export default component.exports